import React from "react";
import { NewDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import Linkify from "react-linkify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { withTranslation } from "react-i18next";
import { Cards, Displays, Headers, Navigations } from "components";

class NewDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await userService.GET_NEW_DETAIL(router.params?.id);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      });
    }
  };

  render() {
    const { t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activity News", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];
    return (
      <NewDetailContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="new_detail_container">
          <Headers.NewPageHeader title={"NEWS"} sub_title={"ข่าวสาร"} />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Cards.NewInfo
              src={data.inside_img}
              title={data.title}
              description={
                // data.description
                <Linkify
                  componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="blank" href={decoratedHref} key={key}>
                      {decoratedText}
                    </a>
                  )}
                >
                  {data.description}
                </Linkify>
              }
            />
          )}
        </div>
      </NewDetailContainerStyled>
    );
  }
}

export default withTranslation(["common"])(withRouter(NewDetailContainer));
